import { OnChanges, Component, Input, OnInit } from '@angular/core';
import { RenaultMyServiceActionDTO, RenaultMyServiceActionResultGlobal } from 'src/app/models/renault-myservice-dto';

@Component({
  selector: 'my-service-action-result-global',
  templateUrl: './my-service-action-result-global.component.html',
  styleUrls: ['./my-service-action-result-global.component.scss']
})
export class MyServiceActionResultGlobaComponent implements OnInit {

  @Input() model: RenaultMyServiceActionDTO;
  @Input() modelResult: RenaultMyServiceActionResultGlobal;


  constructor() { }

  ngOnInit() {    
    
  }

 
}
